import {
	useEffect,
	useState
} from 'react'

import {
	useDispatch
} from 'react-redux'

import {
	removeProspect,
	updateProspect,
	createProspect,
	convertProspect,
} from '../slice'

import {
	getChatRoom,
	setShow as setShowMessageCenter
} from '../../MessageCenter/messageCenterSlice'

import {
	useProspectiveClientIds,
	useProspectiveClient,
	useSetProspectViewer,
	useProspectiveClients,
	useProspectViewer,
	useToggleCreator,
	useCreator,
	useHasCRM,
} from '../hooks'

import useS3DirectUpload from '../../../hooks/useS3DirectUpload'

import LocaleDate from '../../LocaleDate/LocaleDate'

import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import css from '../Styles.module.css'

import Acquisition from './Acquisition'

export default function Viewer(){
	const dispatch = useDispatch()
	const {show,id,mode} = useProspectViewer()
	const {status,prospect} = useProspectiveClient(id)
	const [name,setName] = useState('')
	const [email,setEmail] = useState('')
	const [phone,setPhone] = useState('')
	const [pic,setPic] = useState('')
	const [removePic,setRemovePic] = useState(false)

	const setProspectViewer = useSetProspectViewer()

	const {processUpload} = useS3DirectUpload()

	const [saving,setSaving] = useState(false)
	const handleSave = async ()=>{
		setSaving(true)

		const payload = {
			client_id:id,
			new_user_id:email,
			new_user_email:email,
			new_user_name:name,
			new_phone:phone
		}

		if (Boolean(pic)) {
			const s3Res = await processUpload(pic)
			payload.new_profile_pic_url = s3Res.payload.url
		} else if(removePic) {
			payload.new_profile_pic_url = ''
		} else {
			payload.new_profile_pic_url = prospect.profile_pic
		}

		dispatch(updateProspect(payload)).then(()=>{
			setSaving(false)
			setPic('')
		})

		setProspectViewer({mode:'view'})
	}

	const handleConvert = ()=>{
		if (!window.confirm('Are you sure you want to convert this prospect to a client?')) return 
		dispatch(convertProspect(id))
	}
	
	useEffect(()=>{
		if (!prospect) return

		setName(prospect.user_name)
		setEmail(prospect.user_id)
		setPhone(prospect.phone)

		setRemovePic(false)




	},[prospect])

	
	if(!prospect) return null
	return (
		<Modal show={show} onHide={setProspectViewer.bind(null,{show:false,mode:'view',id:null})}>
			<Modal.Header closeButton>
				Prospect Details
			</Modal.Header>
			<Modal.Body>
				{mode==='view'&&
					<>
						<Button 
							onClick={setProspectViewer.bind(null,{mode:'edit'})}
							variant="outline-primary" 
							block size="sm" 
							className="mb-2"
						>
							Edit
						</Button>
						{Boolean(prospect.profile_pic)&&
							<img 
								src={prospect.profile_pic}
								style={{
									width:'200px',
									height:'200px',
									objectFit:'cover',
									borderRadius:'300px',
									display:'block',
									margin:'auto',
									overflow:'hidden'
								}}
							/>
						}
						<div>
							Name: {prospect.user_name}
						</div>
						<div>
							Email: <a href={`mailto:${prospect.user_id}`}>{prospect.user_id}</a>
						</div>
						<div>
							Phone: {prospect.phone}
						</div>
					</>
				}
				{mode==='edit'&&
					<>
						{(Boolean(prospect.profile_pic)&&!pic&&!removePic)&&
							<>
								<img 
									src={prospect.profile_pic}
									style={{
										width:'200px',
										height:'200px',
										objectFit:'cover',
										borderRadius:'300px',
										display:'block',
										margin:'auto',
										overflow:'hidden'
									}}
								/>
								<Button 
									onClick={setRemovePic.bind(null,true)}
									variant="outline-danger" 
									size="sm" 
									block 
									className="my-2"
								>
									Remove profile image
								</Button>
							</>
						}
						{(Boolean(prospect.profile_pic)&&!pic&&removePic)&&
							<Button 
								onClick={setRemovePic.bind(null,false)}
								variant="outline-success" 
								size="sm" 
								block 
								className="my-2"
							>
								Keep profile image
							</Button>
						}
						{!Boolean(pic)&&
							<Form.File 
								onChange={e=>{
									setPic(e.target.files[0])
								}}
								custom 
								label="New Profile Pic" 
								id="prospect-profile-pic-input"
							/>
						}
						{Boolean(pic)&&
							<div>
								<img 
									src={URL.createObjectURL(pic)} 
									style={{
										width:'200px',
										height:'200px',
										objectFit:'cover',
										maxWidth:'100%',
										borderRadius:'3000px',
										display:'block',
										margin:'auto'
									}}
								/>
								<Button 
									className="my-2"
									variant="outline-danger"
									onClick={setPic.bind(null,'')}
									block
									size="sm"
								>
									Remove Image
								</Button>
							</div>
						}
						<div>
							<strong>Name</strong>
							<Form.Control 
								onChange={e=>{
									setName(e.target.value)
								}}
								placeholder="name" 
								value={name}
							/>
						</div>
						<div>
							<strong>Email</strong>
							<Form.Control 
								onChange={e=>{
									setEmail(e.target.value)
								}}
								placeholder="email" 
								value={email}
							/>
						</div>
						<div>
							<strong>Phone</strong>
							<Form.Control 
								placeholder="phone" 
								value={phone}
								onChange={e=>{
									setPhone(e.target.value)
								}}
							/>
						</div>
						<div className="text-right mt-2">
							<Button 
								onClick={setProspectViewer.bind(null,{mode:'view'})}
								variant="outline-dark" 
								className="mr-1" 
								size="sm"
							>
								Cancel
							</Button>
							<Button 
								onClick={handleConvert}
								variant="outline-primary" 
								className="mr-1" 
								size="sm"
							>
								Convert to Client
							</Button>
							<Button 
								disabled={saving}
								onClick={handleSave}
								variant="outline-success"
								size="sm"
							>
								Save {saving&&<Spinner animation="border" size="sm"/>}
							</Button>
						</div>
					</>
				}
				<Acquisition id={id}/>
				<div>
					{prospect.acquisition_data}
				</div>
			</Modal.Body>
		</Modal>
	)
}